module.exports = __webpack_public_path__ + "static/planbox-fa7e066b6256c672d03f4c5d96c9f484.png";